import { render, staticRenderFns } from "./LmSmallButton.vue?vue&type=template&id=1b50f265&scoped=true&"
import script from "./LmSmallButton.vue?vue&type=script&lang=js&"
export * from "./LmSmallButton.vue?vue&type=script&lang=js&"
import style0 from "./LmSmallButton.vue?vue&type=style&index=0&id=1b50f265&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b50f265",
  null
  
)

export default component.exports